import React, { useEffect, useState } from 'react';
import { EpAvatar } from '../EpAvatar';
import { IEpDropdownDefaultListItems } from '../../interfaces/interfaces/components';

import './EpAvatarDropdownUserMenu.scss';

interface IEpAvatarDropdownUserMenuTranslations {
  manageAccountButtonText: string;
  languageButtonText: string;
  supportButtonText: string;
  knowledgeBaseButtonText: string;
  exitBaseButtonText: string;
}

export interface IEpAvatarDropdownButtonInfos {
  id: string;
  buttonOnClickFunc: () => void;
}

export interface IEpAvatarDropdownUserMenuButtonsListInfos {
  manageAccount: IEpAvatarDropdownButtonInfos;
  language: IEpAvatarDropdownButtonInfos;
  support: IEpAvatarDropdownButtonInfos;
  knowledgeBase: IEpAvatarDropdownButtonInfos;
  exit: IEpAvatarDropdownButtonInfos;
}

interface EpAvatarDropdownUserMenuProps {
  avatarDropdownUserMenuId: string;
  userName: string;
  userEmail: string;
  userRole?: string;
  avatarId: string;
  dropdownId: string;
  dropdownMenuPlacement?: 'start' | 'center' | 'end';
  customClasses?: string;
  currentSystemLanguage: string;
  dropdownDefaultList: IEpAvatarDropdownUserMenuButtonsListInfos;
  translations: IEpAvatarDropdownUserMenuTranslations;
}

export const EpAvatarDropdownUserMenu: React.FC<
  EpAvatarDropdownUserMenuProps
> = ({
  avatarDropdownUserMenuId,
  userName,
  userEmail,
  userRole,
  avatarId,
  dropdownId,
  customClasses = '',
  currentSystemLanguage,
  dropdownDefaultList,
  translations,
}) => {
  const {
    manageAccountButtonText,
    languageButtonText,
    supportButtonText,
    exitBaseButtonText,
  } = translations;
  const [formattedDropdownDefaultList, setFormattedDropdownDefaultList] =
    useState<IEpDropdownDefaultListItems[]>([]);

  const getFormattedLanguageButtonText = (newLanguageCode: string): string => {
    const newLanguage = newLanguageCode || '-';
    return languageButtonText.replace('{0}', newLanguage);
  };

  useEffect(() => {
    const formattedDropdownList: IEpDropdownDefaultListItems[] = [
      {
        buttonId: dropdownDefaultList.manageAccount.id,
        buttonText: manageAccountButtonText,
        buttonLeftIconName: 'SolidAddressBook',
        buttonOnClickFunc: dropdownDefaultList.manageAccount.buttonOnClickFunc,
      },
      {
        buttonId: dropdownDefaultList.language.id,
        buttonText: getFormattedLanguageButtonText(currentSystemLanguage),
        buttonLeftIconName: 'SolidGlobe',
        buttonOnClickFunc: dropdownDefaultList.language.buttonOnClickFunc,
      },
      {
        buttonId: dropdownDefaultList.support.id,
        buttonText: supportButtonText,
        buttonLeftIconName: 'SolidHeadphones',
        buttonOnClickFunc: dropdownDefaultList.support.buttonOnClickFunc,
      },
      // {
      //   buttonId: dropdownDefaultList.knowledgeBase.id,
      //   buttonText: knowledgeBaseButtonText,
      //   buttonLeftIconName: 'SolidBookReader',
      //   buttonOnClickFunc: dropdownDefaultList.knowledgeBase.buttonOnClickFunc
      // },
      {
        buttonId: dropdownDefaultList.exit.id,
        buttonText: exitBaseButtonText,
        buttonLeftIconName: 'SolidSignOutAlt',
        buttonOnClickFunc: dropdownDefaultList.exit.buttonOnClickFunc,
      },
    ];

    setFormattedDropdownDefaultList(formattedDropdownList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      id={avatarDropdownUserMenuId}
      className={`ep-avatar-dropdown-user-menu ${customClasses}`}
    >
      <EpAvatar
        avatarId={avatarId}
        avatarContent="text"
        userName={userName}
        avatarHasDropdown={true}
        dropdownId={dropdownId}
        dropdownDefaultList={formattedDropdownDefaultList}
        customTopElementsDropdownMenu={
          <div className="ep-avatar-dropdown-user-menu__custom-top-elements">
            <h5 className="ep-avatar-dropdown-user-menu__username">
              {userName}
            </h5>
            <p className="ep-avatar-dropdown-user-menu__user-email">
              {userEmail}
            </p>
            {userRole && (
              <span className="ep-avatar-dropdown-user-menu__user-role">
                {userRole}
              </span>
            )}
          </div>
        }
      ></EpAvatar>
    </div>
  );
};
